<template>
  <div>
      <machine-learning-query :key="'machine_learning_query' + d_keyIndex"></machine-learning-query>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import {
  default as MachineLearningQuery
} from '@/components/widgets/MachineLearningQuery';
import { mapGetters } from 'vuex';
export default {
  name: 'user_machine_learning_query_products',
  computed: mapGetters({
    StoreLang: 'StoreLang',
  }),
  components: {
    MachineLearningQuery,
  },
  props: {},
  data () {
    return {
      d_keyIndex: 0
    };
  },
  created: function () {},
  beforeMount () {},
  mounted: function () {},
  methods: {
  },
  watch: {
    'StoreLang': function () {
      this.d_keyIndex ++;
    }
  }
}

</script>

